import script from "./FieldList.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__